module.exports = __webpack_public_path__ + "static/media/upload-matrail.7fd302ce.png";